import { api_urls_http, api_urls_https, recharge_urls_https, web_urls_http, web_urls_https } from "../constants";

export let api_urls;
export let web_urls;
export let recharge_urls;
export let milan_sathi_image_urls = 'https://api.bharatdarshan.app';

if (window.location.protocol === 'http:') {
    api_urls = api_urls_http;
    web_urls = web_urls_http;
    recharge_urls = recharge_urls_https;
} else if (window.location.protocol === 'https:') {
    api_urls = api_urls_https;
    web_urls = web_urls_https;
    recharge_urls = recharge_urls_https;
} else {
    console.log('Unknown protocol');
};